class SiteMobileMenu {
  constructor() {
    this.mobileMenu = document.querySelector('.site-mobileMenu');
    this.mobileMenuTrigger = document.querySelector('.site-header__mainMenu__mobileTrigger')

    if(!this.mobileMenu || !this.mobileMenuTrigger) return

    this.initMobileMenu()
  }

  initMobileMenu () {
    this.mobileMenuTrigger.addEventListener('click', () => {
      this.mobileMenuTrigger.classList.toggle('active')
      this.mobileMenu.classList.toggle('active')
    })
  }
}

class HomeQuestionnaires {
  constructor() {
    this.questions = document.querySelectorAll('.home-questionnaire__question')
    this.backTrigger = document.querySelector('.home-questionnaire__backTrigger')
    this.questionCount = 0
    this.userAnswers = []

    if(this.questions.length === 0) return 

    this.initFirstQuestionnaire()
    this.initQuestionnaires()
    this.initBackTrigger()
  }

  initFirstQuestionnaire() {
    this.initSlider(this.questions[0], '.home-questionnaire__answers')
  }

  initQuestionnaires() {
    this.questions.forEach((question, questionIndex) => {
    const answers = question.querySelectorAll('.home-questionnaire__answer')
    
    answers.forEach(answer => {
      const products = answer.getAttribute('data-products').split(',').filter(product => product !== '')

      answer.addEventListener('click', () => {
        this.handleAnswerClick(products, answers, answer, questionIndex)
      })
    })
  })
  }

  initBackTrigger() {
    this.backTrigger.addEventListener('click',() => this.handleBackTriggerClick())
  }

  handleAnswerClick(products, answers, answer, questionIndex) {
    this.userAnswers[questionIndex] = products

//     $.post("/cap/track.php", {tr: questionIndex}, function(result){
//       var pw_reset_form = $.parseJSON(result);
//     })

    this.fadeOutCards(answers,answer,'home-questionnaire__answer--transparent')
    
    if(this.questionCount !== this.questions.length - 1) {
     this.changeQuestion(questionIndex, 1)
    } else {
      this.finishQuestionnaire()
    }
  }

  fadeOutCards(cards,el,toggledClass) {
    cards.forEach(card => {
      if(!el.isEqualNode(card)) {
        card.classList.add(toggledClass)
      } else card.classList.remove(toggledClass)
    })
  }

  changeQuestion(index, increment) {
    this.questionCount = index + increment

    this.toggleSliderVisibility(increment)

    this.initSlider(this.questions[this.questionCount], '.home-questionnaire__answers')

    if(this.questionCount !== 0) {
      this.backTrigger.classList.add('home-questionnaire__backTrigger--visible')
    } else {
      this.backTrigger.classList.remove('home-questionnaire__backTrigger--visible')
    }
  }

  finishQuestionnaire() {
    const results = {}
      this.userAnswers.forEach(userAnswer => {
        userAnswer.forEach(product => {
          if(results.hasOwnProperty(product)) {
            results[product]++
          } else results[product] = 1
        })
      })

      this.finalResult = Object.keys(results).reduce((a, b) => results[a] > results[b] ? a : b);

      const matchingResults = Object.keys(results).filter((product) => results[product] === results[this.finalResult])
      
      this.finalResult = matchingResults[Math.floor(Math.random() * 2)]
      
      if(!this.finalResult) return

      this.getResultPost()
  }

  getResultPost() {
    const location = window.location.pathname.replace(/\\|\//g,'')
    fetch(`/wp-json/products/${this.finalResult}?location=${location}`)
      .then(response => response.json())
      .then(({title,thumbnail,body,button,headingBody}) => {
          const resultContainer = document.querySelector('.home-questionnaire__result')
          const resultImage = document.querySelector('.home-questionnaire__result__image')
          const resultHeading = document.querySelector('.home-questionnaire__result__cardHeading')
          const resultHeadingBody = document.querySelector('.home-questionnaire__result__headingBody')
          const resultBody = document.querySelector('.home-questionnaire__result__body')
          const resultButton = document.querySelector('.home-questionnaire__result__button')

            if(title) {
              resultHeading.innerHTML = title
            }

            if(thumbnail) {
              resultImage.src = thumbnail
            }

            if(body) {
              resultBody.innerHTML = body
            }

            if(headingBody) {
              resultHeadingBody.innerHTML = headingBody
            }

            if(button) {
              const buttonInner = resultButton.querySelector('.btn__text')
              buttonInner.innerHTML = button.label
              resultButton.href = button.url
            }

            resultContainer.classList.remove('home-questionnaire__result--hidden')
            resultContainer.scrollIntoView({behavior:'smooth'})
      })
  }

  initSlider(el,selector) {
    const sliderContainer = el.querySelector(selector)

    if(!sliderContainer) return

    return new Swiper(sliderContainer,{
      slidesPerView: 'auto',
      centeredSlides: true,
      threshold: 10,
      breakpoints: {
        992: {
          threshold: 999999,
          centeredSlides: false,
        }
      }
    })
  }

  toggleSliderVisibility() {
    const mediaQuery = window.matchMedia('(min-width: 992px)')

    this.questions.forEach((question,index) => {
        question.classList.remove('home-questionnaire__question--previous')

       if(index === this.questionCount) {
        question.classList.add('home-questionnaire__question--current')
      } else {
        question.classList.remove('home-questionnaire__question--current')
      }

      if(index < this.questionCount) {
        question.classList.add('home-questionnaire__question--previous')
      }
     
    })
    
    this.questions[this.questionCount].classList.add('home-questionnaire__question--current')

    if(mediaQuery.matches) {
      this.questions[this.questionCount].scrollIntoView({behavior:'smooth'})
    } else {
      // this.questions[this.questionCount-increment].classList.add('home-questionnaire__question--hidden')
    }
  }

  handleBackTriggerClick() {
    this.changeQuestion(this.questionCount, -1)
  }
}